import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BankAccountRequest, PagedList, SupplierFullModel } from '../interface';
import { BankAccountInfoModel, ContractModel, ContractRequest, SupplierModel, SupplierResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxSupplierService {
  constructor(
    private api: SupplierResourceService,
  ) {
  }

  getSuppliers(params?: {
    page?: number,
    limit?: number,
    query?: string,
    storeIds?: number[],
    countryIds?: number[],
    organizationId?: number,
  }): Observable<PagedList<SupplierModel>> {
    return this.api.getSuppliers(params?.countryIds, params?.limit, params?.organizationId, params?.page, params?.query, params?.storeIds) as unknown as Observable<PagedList<SupplierModel>>;
  }

  getSupplierById(supplierId: number): Observable<SupplierFullModel> {
    return this.api.getSupplierById(supplierId) as unknown as Observable<SupplierFullModel>;
  }

  saveSupplier(body: any): Observable<SupplierModel> {
    return this.api.saveSupplier(body) as unknown as Observable<SupplierModel>;
  }

  removeSupplier(supplierId: number): Observable<any> {
    return this.api.removeSupplier(supplierId);
  }

  // addresses
  getSupplierAddressesById(supplierId: number): Observable<any> {
    return this.api.getAddresses(supplierId);
  }

  removeSupplierAddress(supplierId: number, addressId: number): Observable<any> {
    return this.api.removeSupplierAddress(addressId, supplierId);
  }

  createSupplierAddress(supplierId: number, body: any): Observable<any> {
    return this.api.insertAddress(supplierId, body);
  }

  updateSupplierAddress(supplierId: number, addressId: number, body: any): Observable<any> {
    return this.api.updateAddress(addressId, supplierId, body);
  }

  // supplier's bank
  getSupplierBankAccountList(supplierId: number): Observable<BankAccountInfoModel[]> {
    return this.api.getBankAccounts(supplierId) as unknown as Observable<BankAccountInfoModel[]>;
  }

  removeSupplierBankAccount(supplierId: number, bankId: number): Observable<any> {
    return this.api.removeSupplierBankAccount(bankId, supplierId);
  }

  saveSupplierBankAccount(supplierId: number, body: BankAccountRequest): Observable<any> {
    return this.api.saveSupplierBankAccount(supplierId, body as any);
  }

  // supplier's contract
  getSupplierContractList(supplierId: number): Observable<ContractModel[]> {
    return this.api.getSupplierContracts(supplierId);
  }

  removeSupplierContract(supplierId: number, contractId: number): Observable<void> {
    return this.api.removeSupplierContract(contractId, supplierId);
  }

  createSupplierContract(supplierId: number, body: ContractRequest): Observable<ContractModel> {
    return this.api.insertContract(supplierId, body);
  }

  updateSupplierContract(supplierId: number, contractId: number, body: ContractRequest): Observable<ContractModel> {
    return this.api.updateSupplierContract(contractId, supplierId, body);
  }
}
